import React, { Component, PropTypes } from 'react'
import _isEqual from 'lodash/isEqual'
import './Actions.scss'
import { base, colours, CScolours, debounceTime, statuses } from '../../../config'
import {Link} from 'react-router'
import Overview from '../../components/Overview'
import JobViews from '../../components/JobViews'

export class Actions extends Component {

    constructor(props) {
        super(props);
        this.state = {
          edit: false,
          menuOpen: true,
          delete: false
        }
        this._delete = this._delete.bind(this)
        this._fullDelete = this._fullDelete.bind(this)
    }

    _menuOpen () {
      this.setState({
        menuOpen: !this.state.menuOpen
      })
    }

    _delete () {
      this.setState({
        delete: !this.state.delete
      })
    }

    _fullDelete () {
      this.props._deleteTab()
      this.setState({
        delete: !this.state.delete
      })
    }

    render() {
        const {mainJob} = this.props
        const tabName = _.get(this.props.job[this.props.active], 'name', '')
        const totalCost = mainJob.total.cost
        const totalSale = mainJob.total.sale
        const totalProfit = totalSale - totalCost

        return (
          <div className="job-actions">

            {!this.props.mobile &&
              <div className="visible-xs">
                <div className="panel-footer">
                  <JobViews _view={this.props._view} view={this.props.view} jobId={this.props.jobId} />
                </div>
              </div>
            }

            <div className='hidden-xs'>
              <div className='panel panel-secondary panel-tab tab-br'>
                <div className="panel-heading">
                  sadf
                  <a className='open-close hidden-xs' onClick={this._menuOpen.bind(this)}>
                    {!this.state.menuOpen &&
                      <span>Open <i className="icon-arrow-down"></i></span>
                    }
                    {this.state.menuOpen &&
                      <span>Close <i className="icon-arrow-up"></i></span>
                    }
                  </a>
                </div>
                <div className="panel-body">
                  <div name="tab_name" className="tabs">
                    <ul><li className="active"><a>Tab Name</a></li></ul>
                    <div className='actions mobile-sheet save-btn' style={{marginTop: -15}}>
                      <div className='row'>
                        <div className='col-xs-8 col-sm-8'>
                          <input value={this.props.tabName} onChange={(e) => this.props._tabName(e.target.value)} ref="new_tab" type="text" className="form-control" name="q" placeholder="New Tab" />
                        </div>
                        <div className='col-xs-4 col-sm-4'>
                          <button onClick={this._delete} className="btn btn-danger btn-block">Delete</button>
                        </div>
                      </div>
                      {this.state.delete &&
                        <div className='m-t-md'>
                          <label htmlFor="">Do you really want to delete this tab?</label><br/>
                          <div className='row'>
                            <div className='col-sm-6'>
                              <button onClick={this._delete} type="button" className='btn btn- btn-block btn-info'>NO</button>
                            </div>
                            <div className='col-sm-6'>
                            <button onClick={this._fullDelete} type="button" className='btn btn- btn-block btn-danger'>YES</button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                {this.state.menuOpen && !this.props.mobile &&
                  <div className="hidden-xs panel-footer">
                    <JobViews _view={this.props._view} view={this.props.view} jobId={this.props.jobId} />
                  </div>
                }
              </div>
            </div>

            <div className="visible-xs"><br/></div>

            {!this.props.mobile && this.props.view === 'tabs-view' &&
              <div className='visible-xs'>
                <div className='panel panel-secondary panel-tab tab-br'>
                  <div className="panel-heading">
                    sadf
                    <a className='open-close hidden-xs' onClick={this._menuOpen.bind(this)}>
                      {!this.state.menuOpen &&
                        <span>Open <i className="icon-arrow-down"></i></span>
                      }
                      {this.state.menuOpen &&
                        <span>Close <i className="icon-arrow-up"></i></span>
                      }
                    </a>
                  </div>
                  <div className="panel-body">
                    <div name="tab_name" className="tabs">
                      <ul><li className="active"><a>Tab Name</a></li></ul>
                      <div className='actions mobile-sheet save-btn' style={{marginTop: -15}}>
                        <div className='row'>
                          <div className='col-xs-8 col-sm-8'>
                            <input value={this.props.tabName} onChange={(e) => this.props._tabName(e.target.value)} ref="new_tab" type="text" className="form-control" name="q" placeholder="New Tab" />
                          </div>
                          <div className='col-xs-4 col-sm-4'>
                            <button onClick={this._delete} className="btn btn-danger btn-block">Delete</button>
                          </div>
                        </div>
                        {this.state.delete &&
                          <div className='m-t-md'>
                            <label htmlFor="">Do you really want to delete this tab?</label><br/>
                            <div className='row'>
                              <div className='col-sm-6'>
                                <button onClick={this._delete} type="button" className='btn btn- btn-block btn-info'>NO</button>
                              </div>
                              <div className='col-sm-6'>
                              <button onClick={this._fullDelete} type="button" className='btn btn- btn-block btn-danger'>YES</button>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }


            {!this.props.mobile &&
              <div className='hidden-xs'>
                <Overview
                  profit={totalProfit}
                  cost={totalCost}
                  sale={totalSale}
                />
              </div>
            }


            {this.props.mobile &&
              <div className='visible-xs'>
                <Overview
                  profit={totalProfit}
                  cost={totalCost}
                  sale={totalSale}
                />
              </div>
            }

          </div>

        )
    }
}

export default Actions



// WEBPACK FOOTER //
// ./src/views/components/Actions/index.js